module.exports = __webpack_public_path__ + "static/stalingrad-03e6b4b08b7ab429229fe914a17e0999.jpg";